export const iconTypes = {
  add: "fa-plus",
  delete: "fa-minus",
  modify: "fa-circle-small",
};
